// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IEventTriggerConverter {
	canWrite: boolean;

	canRead: boolean;

	$type?: string | undefined;
}
export class EventTriggerConverter {
	constructor(data?: IEventTriggerConverter) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	canWrite: boolean = false;

	canRead: boolean = false;

	static $type: string = "CoreApi.Models.ClientEndpoints.EventTriggerConverter, ";
	$type?: string | undefined = EventTriggerConverter.$type;
}

